module.exports = __webpack_public_path__ + "static/img/3_2_6.a8c81d89.jpg";